;(function() {
/* @ngInject */
function CartV2() {
  return {
    restrict: "E",
    templateUrl: "/app/shared/cart-v2/cart-v2-view.html",
    scope: {
      cart: "<",
      saveAndContinueFunction: "&",
      nextStep: "<",
      hidePrice: "<",
      mode: "@"
    }
  };
}

angular.module("firmaren")
  .directive("firmarenCartV2", CartV2);
}());
